import { Component, Input, AfterViewInit, Inject } from '@angular/core';
import { take, map } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

export interface ConfirmModel {
  title: string;
  access?: string[];
  textTimer: number;
}

@Component({
  selector: 'app-access-dialog-search',
  templateUrl: './access-dialog-search.component.html',
  styleUrls: ['./access-dialog-search.component.scss']
})
export class AccessDialogSearchComponent {
  @Input() title: string = "";
  @Input() access: string[] = [];
  @Input() textTimer: number = 0;

  confirmData: ConfirmModel = {
    title: "",
    access: [],
    textTimer: 0
  };

  //public tabla: any[] = [];
  tabla = new MatTableDataSource<{value: string}>();

  public counter$: Observable<number> = new Observable;

  public counter = 0;

  constructor(public dialogRef: MatDialogRef<AccessDialogSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel,) {
      this.confirmData = data;
      this.generateTabla();

      timer(0, 1000).pipe(
        // Take values until the specified duration is reached
        take(this.confirmData.textTimer + 1),
        // Subtract the emitted values from the duration to get the countdown
        map((value) => this.confirmData.textTimer - value)
      ).subscribe((counter) => {
        this.counter = counter;
        // Close the dialog when the countdown reaches zero
        if (counter === 0) {
          // this.close();
        }
      });
  }

  generateTabla(): void {
    if (this.confirmData.access && this.confirmData.access.length > 0) {
      const tablaAux = this.confirmData.access.map((item) => {
        return { value: item };
      });

      this.tabla = new MatTableDataSource<{value: string}>(tablaAux);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tabla.filter = filterValue.trim().toLowerCase();
  }

  //confirm
  confirm() {
    // we set modal result as true on click on confirm button,
    // then we can get modal result from caller code
    // this.result = true;
    // this.close();
    this.dialogRef.close(true);
  }

  //cancel
  close() {
    this.dialogRef.close(false);
  }

  async ngAfterViewInit(): Promise<void> {
    if (this.confirmData.textTimer > 0) {
      this.counter$ = await timer(0, 1000).pipe(
        take(this.textTimer),
        map(() => {
          return --this.textTimer
        }));
    }
  }
}
